import React from "react";
import { Tag } from "antd";

export const ColorText = (status: any) => {
  if (
    ["Kompletan", "Комплетан"].includes(status) ||
    ["Spreman za preuzimanje", "Спреман за преузимање"].includes(status) ||
    ["Izvršeno plaćanje", "Извршено плаћање"].includes(status) ||
    ["Odobreno", "Одобрено"].includes(status) ||
    ["Podnet", "Поднет"].includes(status) ||
    ["Aktivirana", "Активирана"].includes(status)
  )
    return <Tag color="green">{status}</Tag>;
  if (["Nepotpun", "Непотпун"].includes(status))
    return <Tag color="purple">{status}</Tag>;
  if (["Vraćen na dopunu", "Враћен на допуну"].includes(status))
    return <Tag color="yellow">{status}</Tag>;
  if (["U obradi", "У обради"].includes(status))
    return <Tag color="orange">{status}</Tag>;
  if (["Odbijen", "Одбијен"].includes(status))
    return <Tag color="red">{status}</Tag>;
  if (["Nije razdužena obavezna količina izdatih kontrolnih akciznih markica", "Није раздужена обавезна количина издатих контролних акцизних маркица"].includes(status))
    return <Tag color="volcano">{status}</Tag>;
  return <Tag>{status}</Tag>;
};
